import React from 'react';
import clsx from 'clsx';
import { STATUS, PRIORITY, TONE_BADGE, statusOf } from '../../utils/status';

// A status word, written for people and coloured by meaning (see utils/status.js).
// <StatusPill status="cancelled_with_charge" /> → grey 'Cancelled (charged)'.
// Pass `tone` or `label` to override one record's wording without inventing a new colour.
export function StatusPill({ status, label, tone, map = STATUS, className }) {
  const s = statusOf(status, map);
  return (
    <span className={clsx(TONE_BADGE[tone || s.tone] || 'badge-gray', 'whitespace-nowrap', className)}>
      {label || s.label}
    </span>
  );
}

export function PriorityPill({ priority, className }) {
  return <StatusPill status={priority} map={PRIORITY} className={className} />;
}

export default StatusPill;
